import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom';
import {globalRouter} from "lib/global-router";

const validateToken = (token) => {
    let validationResult = {
        isValid: false,
        isExpired: false,
    };

    if (!token) return validationResult;

    const parseJwt = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };

    const parsedJwt = parseJwt(token);
    if (!parsedJwt) return validationResult;

    if (parsedJwt.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        validationResult.isValid = true;
        validationResult.isExpired = true;

        return validationResult;
    } else {
        validationResult.isValid = true;
        validationResult.isExpired = false;
        return validationResult;
    }
};

const protectedPaths = ['/find-vin', '/reports', '/pages/selectedResult'];

const RouteAuthenticator = () => {
    globalRouter.navigate = useNavigate();
    const location = useLocation();
    if (protectedPaths.includes(location.pathname)) {
        const token = localStorage.getItem('token');
        const {isExpired, isValid} = validateToken(token);

        return isValid && !isExpired ? <Outlet/> : <Navigate to={'/login'} state={{isTokenExpired: isExpired, from: location}} replace />
    } else {
        return <Outlet />
    }
}

export default RouteAuthenticator;